angular.module('EdxClassroomReportModule')
  .controller('EdxClassroomReportController', [
    '$scope',
    '$state',
    'classroomApi',
    'edxStateParamsService',
    'timeframe',
    function (
      $scope,
      $state,
      classroomApi,
      edxStateParamsService,
      timeframe) {

      var params = _.pick($state.params, ['districtId']);
      params.classroom_id = $state.params.classroomId;
      params = _.extend(params, edxStateParamsService.getTimeframeParamsForEarlyHighlights());

      classroomApi.getClassroomHighlights(params).then(function (classroomData) {
        /*
        * we used to retrieve this data from the District highlights API endpoint, the API is now deprecated.
        * The only thing used with the response was the reporting_years property and that was returning a null value.
        * With this change we ensure we use the current year and last year to populate the timeframe and also send a
        * value to the getYearListSubject and with that the timeframe dropdown gets populated correctly
        */
        var years = [params.sy - 1, params.sy];
         timeframe.getYearListSubject().onNext(years);
         // deprecated: use timeframe.getYearListSubject instead of broadcast
         $scope.$broadcast('updateYears', years);
         return classroomData;
      });
    }
  ]);
